<template>
	<ul class="stamp-list stamp-grid">
		<AsStampStatusListItem
			v-for="(item, index) of userAsStampList"
			:key="index"
			@click-stamp="clickStamp(index)"
		/>
	</ul>
</template>

<script>
import AsStampStatusListItem from './AsStampStatusListItem';

import { formatDateString } from '@/utils/util';

export default {
	components: {
		AsStampStatusListItem,
	},
	data() {
		return {
			asDetail: {},
		};
	},
	computed: {
		userId() {
			return this.$store.getters['userStore/userId'];
		},
		userAsStampList() {
			return this.$store.getters['asStore/userAsStampList'] || [];
		},
		branchName() {
			return this.$store.getters['appStore/branchName'] || '';
		},
	},
	created() {
		this.fetchUserAsStampList();
	},
	methods: {
		async fetchUserAsStampList() {
			const payload = {
				userId: this.userId,
			};
			return await this.$store.dispatch('asStore/getUserAsStampList', payload);
		},
		async fetchBranchNameFromBranchCode() {
			const payload = {
				branchCode: this.asDetail.SAUPJANG,
			};
			return await this.$store.dispatch(
				'appStore/getbranchNameFromBranchCode',
				payload,
			);
		},
		clickStamp(index) {
			// set detail data
			this.setAsDetail(this.userAsStampList[index]);

			// fetch branch name
			this.fetchBranchNameFromBranchCode().then(() => {
				// open dialog
				this.openAsDetailDialog();
			});
		},
		setAsDetail(detail) {
			this.asDetail = detail;
		},
		getAsDetailInfo() {
			const branchInfo = this.branchName ? `지점: ${this.branchName}\n` : '';
			const info = `날짜: ${formatDateString(this.asDetail.PYMNT_DT)}
			내용: ${this.asDetail.SV_NAME}
			`;

			return `${branchInfo}${info}`;
		},
		openAsDetailDialog() {
			const message = this.getAsDetailInfo();
			const options = {
				title: '관리 서비스 내역',
				message,
				okLabel: '닫기',
			};
			this.showAlert(options);
		},
	},
};
</script>
